module.exports = __webpack_public_path__ + "static/media/air-condition-house.5c78bda1.jpg";